export default info => {
  let amount = info.frontmatter.vidHeight / info.frontmatter.vidWidth
  let clean = amount * 100 + "%"
  return clean
}
